import Price from './price';

function Travelline(parent, search) {
    Price.call(this, parent, search);
}

Travelline.prototype = Object.create(Price.prototype);
Object.defineProperty(Travelline.prototype, 'constructor', {
    value: Travelline,
    enumerable: false,
    writable: true,
});

export default Travelline;
